import ApplicantBirthPlace from './ApplicantBirthPlace';

export default ApplicantBirthPlace;
